import React, { useState, useEffect } from "react";
import "../styles/index.less";
import {
  Row,
  Layout,
  Button,
  Carousel,
  Form,
  Input,
  Upload,
  Switch,
  message,
  Tooltip,
  Col,
  Card,
  Popconfirm,
} from "antd";
import { useParams } from "react-router-dom";
import { DoubleRightOutlined, UploadOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import {
  announcement_update,
  get_all_announcement,
  get_announcement,
} from "../../../services/announcement";
import { upload_file } from "../../../services/uploads";
import { useTranslation } from "react-i18next";

const { Content } = Layout;

type Props = {};

const UploadBanner = (props: Props) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const params = useParams();
  const { t } = useTranslation();
  const [uploadDisabled, setUploadDisabled] = useState(false);
  const { name_announcement } = useParams<{ name_announcement: string }>();
  const [imageUrls, setImageUrls] = useState<string[]>([]);
  const [formData, setFormData] = useState({
    title: "",
    readMore: false,
    url: "",
    backcolor: null,
    detail: null,
    summarize: null,
    textPosition: null,
    colortitle: null,
    colordetail: null,
    colorbutton: null,
    colorbackground: null,
  });
  const [_, forceUpdate] = useState({});
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [announcementId, setAnnouncementId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [announcementname, setAnnouncementName] = useState<string | null>(null);

  const handleFormChange = (changedValues: any, allValues: any) => {
    setFormData(allValues);
  };

  const beforeUpload = (file: File) => {
    const url = URL.createObjectURL(file);
    setImageUrls([...imageUrls, url]);
    setUploadDisabled(true);
    return false;
  };

  const getBase64 = (file: File, callback: (imageUrl: string) => void) => {
    const reader = new FileReader();
    reader.onload = () => callback(reader.result as string);
    reader.readAsDataURL(file);
  };

  const handleSubmit = (values: any) => {
    message.success("Submit success!");
  };

  // // api Announce
  // useEffect(() => {
  //   getAnnounce();
  //   getAnnouncebyid();
  // }, []);

  // useEffect(() => {
  //   if (params.action === "edit") {
  //     getAnnouncebyid(); // โหลดข้อมูลเฉพาะเมื่อเป็นโหมดแก้ไข
  //   }
  // }, [params.action, name_announcement]);
  // Combined useEffect for API Announce

  useEffect(() => {
    getAnnounce(); // เรียกใช้ทุกครั้งที่ component โหลด
    if (params.action === "edit") {
      getAnnouncebyid(); // โหลดข้อมูลเฉพาะเมื่ออยู่ในโหมดแก้ไข
    }
  }, [params.action, name_announcement]); // Dependency จะทำงานเมื่อ params.action หรือ name_announcement เปลี่ยนแปลง

  const getAnnounce = async () => {
    try {
      const res = await get_all_announcement();
      if (res.result && Array.isArray(res.result)) {
        const matchedAnnounce = res.result.find(
          (item: { title: string | undefined }) =>
            item.title === name_announcement
        );
        if (matchedAnnounce) {
          setAnnouncementId(matchedAnnounce.announcement_id);
        } else {
          console.warn("⚠️ No matching announcement found.");
        }
      }
    } catch (error) {
      console.error("❌ Error fetching announcements:", error);
    }
  };

  const createannouncement = async () => {
    setIsLoading(true);
    try {
      const titleValue =
        params.action === "new" ? name_announcement : announcementname;
      // ✅ เตรียมข้อมูล
      const data = {
        announcement_id: announcementId,
        title: form.getFieldValue("title"),
        img: form.getFieldValue("image"),
        link: null,
        content: [
          {
            details: [
              {
                url: form.getFieldValue("url") ?? "",
                textPosition: null,
                readMore: form.getFieldValue("readMore") ?? false,
              },
            ],
          },
        ],
      };
      // ✅ เรียก API
      const res = await announcement_update(data);
      if (res.status === "success") {
        message.success(
          params.action === "new" ? "Create Success!" : "Update Success!"
        );
        navigate("/announcement");
        window.scrollTo(0, 0);
      } else {
        message.error("❌ API call failed: " + JSON.stringify(res));
      }
    } catch (e) {
      console.error("❌ Error:", e);
      message.error("Error occurred while updating data.");
    }
    setIsLoading(false);
  };

  const getAnnouncebyid = async () => {
    try {
      const res = await get_all_announcement();
      if (res.result && Array.isArray(res.result)) {
        const matchedAnnounce = res.result.find(
          (item: { announcement_id: string | undefined }) =>
            item.announcement_id === params.task_id
        );
        if (matchedAnnounce) {
          // ✅ อัปเดต `announcement_id`
          setAnnouncementId(matchedAnnounce.announcement_id);
          setAnnouncementName(matchedAnnounce.title);

          let parsedContent = [];
          try {
            parsedContent = matchedAnnounce.content
              ? JSON.parse(matchedAnnounce.content)
              : [];
          } catch (error) {
            console.error("❌ Error parsing content JSON:", error);
          }

          // ✅ ดึงค่าจาก `details` ใน `content`
          const details = parsedContent?.[0]?.details?.[0] || {};

          // ✅ เซ็ตค่าลงในฟอร์ม
          form.setFieldsValue({
            title: matchedAnnounce.title,
            image: matchedAnnounce.img || "", // ถ้ามีภาพให้แสดง
            textPosition: details.textPosition || "left",
            readMore: details.readMore || false,
            url: details.url || "",
          });

          if (matchedAnnounce.img) {
            setImageUrls([matchedAnnounce.img]);
          }
        } else {
          console.warn("⚠️ No matching announcement found.");
        }
      }
    } catch (error) {
      console.error("❌ Error fetching announcements:", error);
    }
  };



  return (
    <Layout>
      <Content style={{ padding: "0px 20px 20px 20px" }}>
        <h2 style={{ textAlign: "center", paddingTop: "20px" }}>{t("Preview")}</h2>
        <Carousel>
          {imageUrls.length === 0 ? (
            <div>
              <Row
                align="middle"
                className="carouselmain"
                style={{
                  // height: "500px",
                  background: "#FFFFFF",
                  border: "1px solid #DADADA",
                  borderRadius: "10px",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      textAlign: "center",
                      fontSize: "40px",
                      lineHeight: "500px",
                    }}
                  >
                    Preview
                  </div>
                  {formData.readMore && (
                    <Button type="link" className="button-banner">
                      Read More <DoubleRightOutlined />
                    </Button>
                  )}
                </div>
              </Row>
            </div>
          ) : (
            imageUrls.map((url, index) => (
              <div key={index}>
                {/* <h2 style={{ textAlign: 'center', paddingTop: "20px" }}>Preview</h2> */}
                <Row
                  align="middle"
                  className="carouselmain"
                  style={{
                    // height: "500px",
                    background: "#FFFFFF",
                    border: "1px solid #DADADA",
                    borderRadius: "10px",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <img
                      // src={url}
                      // src={`${process.env.REACT_APP_API}${url}`}
                      src={
                        params.action === "new"
                          ? url
                          : `${process.env.REACT_APP_API}${url}`
                      }
                      alt={`uploaded-${index}`}
                      className="title-image"
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "10px",
                      }}
                    />
                    {formData.readMore && (
                      <Button
                        type="link"
                        className="button-banner"
                        style={{
                          position: "absolute",
                          bottom: "50px",
                          left: "30px",
                        }}
                      >
                        Read More <DoubleRightOutlined />
                      </Button>
                    )}
                  </div>
                </Row>
              </div>
            ))
          )}
        </Carousel>
      </Content>

      {/* input */}
      <Content style={{ padding: "20px 20px 20px 20px" }}>
        <Card
          title={t("upload announcement")}
          style={{
            width: "100%",
            backgroundColor: "#F3F3F1",
            borderColor: "#cccccc",
          }}
        >
          <Form
            form={form}
            name="basic"
            initialValues={{ remember: true }}
            layout="vertical"
            onValuesChange={handleFormChange}
            onFinish={createannouncement}
          >
            <Form.Item
              label={t("name announcement")}
              name="title"
              initialValue={name_announcement}
            >
              <Input />
            </Form.Item>

            <Row gutter={8} align="middle">
              <Col flex="auto">
                <Form.Item label={t("upload announcement")} name="image">
                  <Input
                    placeholder="Link image"
                    disabled
                    // ={!!form.getFieldValue("image")}
                  />
                </Form.Item>
              </Col>
              <Col>
                {form.getFieldValue("image") ? (
                  <Tooltip placement="bottom" title="Clear Path">
                    <Button
                      danger
                      icon={"X"}
                      onClick={() => {
                        setImageUrl(null);
                        form.setFieldsValue({ image: null });
                        forceUpdate({});
                      }}
                    />
                  </Tooltip>
                ) : (
                  <Tooltip placement="bottom" title="Upload">
                    <Upload
                      beforeUpload={beforeUpload}
                      showUploadList={false}
                      maxCount={1}
                      onChange={async (info: any) => {
                        if (info.fileList.length > 0) {
                          const file = info.fileList[0].originFileObj;
                          const fileName = info.fileList[0].name;

                          getBase64(file, (imageUrl: string) => {
                            setImageUrl(imageUrl);
                          });

                          try {
                            const uploadResponse = await upload_file({
                              task_id: "banner_image",
                              type: "banner",
                              name: fileName,
                              file: file,
                            });

                            if (uploadResponse.status === "success") {
                              form.setFieldsValue({
                                image: uploadResponse.link,
                              });
                              forceUpdate({});
                            } else {
                              console.warn("Failed to upload image.");
                            }
                          } catch (uploadError) {
                            console.error(
                              "❌ Error uploading image:",
                              uploadError
                            );
                            message.error("Failed to upload image.");
                          }
                        }
                      }}
                    >
                      <Button
                        style={{
                          backgroundColor: "#0E21A0",
                          color: "white",
                        }}
                        icon={<UploadOutlined />}
                      ></Button>
                    </Upload>
                  </Tooltip>
                )}
              </Col>
            </Row>

            <Form.Item
              label="ปุ่ม (Read more)"
              name="readMore"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            {form.getFieldValue("readMore") && (
              <Form.Item
                name="url"
                label="URL"
                rules={[
                  { required: true, message: "Please input your URL!" },
                  { type: "url", warningOnly: true },
                  { type: "string", min: 6 },
                ]}
              >
                <Input placeholder="input placeholder" />
              </Form.Item>
            )}

            <Form.Item>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "30px",
                }}
              >
                <Popconfirm
                  title={t("Alert title")}
                  description={t("Alert cancel announcement")}
                  onConfirm={() => navigate("/announcement")} // นำทางเมื่อกดตกลง
                  okText="ใช่"
                  cancelText="ไม่"
                >
                  <Button style={{ margin: "0 8px" }}>
                  {t("cancel")}
                  </Button>
                </Popconfirm>
                <Popconfirm
                  title={params.action === "new" ? t("Alert confirm create title") : t("Alert confirm update title")}
                  description={params.action === "new" ? t("Alert create detail announcement") : t("Alert update detail announcement")}
                  onConfirm={() => form.submit()} // ดำเนินการ submit form เมื่อกดตกลง
                  okText={t("yes")}
                  cancelText={t("no")}
                >
                  <Button loading={isLoading} type="primary" htmlType="button">
                    {params.action === "new" ? t("create announcement") : t("update Announcement")}
                  </Button>
                </Popconfirm>
                {/* <Button type="primary" htmlType="submit">
                  {params.action === "new"
                    ? "Create Announcement"
                    : "Update Announcement"}
                </Button> */}
              </div>
            </Form.Item>
          </Form>
        </Card>
      </Content>
    </Layout>
  );
};

export default UploadBanner;
